import styled from 'styled-components';

export const AllHistoryButtonStyles = styled.div`
  display: flex;
  align-items: center;
  padding: 14px 16px;
  background: radial-gradient(80% 80% at 11.61% 20%, #e8f4ff 0%, #c7e4fe 100%);
  margin-top: 16px;
  border-radius: 4px;
  justify-content: space-between;

  .text-container {
    display: flex;
    align-items: center;
  }

  .check-icon {
    width: 24px;
    height: 24px;
  }

  .text {
    margin-left: 12px;
    white-space: nowrap;
  }

  @media (max-width: 500px) {
    align-items: flex-start;
    flex-direction: column;

    .text-container {
      margin-bottom: 9px;
    }

    .button {
      align-self: center;
    }
  }
`;
